(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etr-featured-product"] && !Shopify.designMode) return;
  try {
    
  class EtrFeaturedProduct extends HTMLElement {
    connectedCallback() {
      this.isTouch = window.matchMedia('(hover: none)').matches;
      this.peekDelay = parseInt(this.dataset.peekDelay || '1200', 10);
      this.enableSticky = this.dataset.enableSticky === 'true';
      this._peekTimer = null;
      this._io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 0.6] });
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      clearTimeout(this._peekTimer);
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.isTouch && entry.intersectionRatio >= 0.6 && !this._peekTimer) {
            this._peekTimer = setTimeout(() => {
              this.classList.add('is-peeking');
            }, this.peekDelay);
          }
          if (this.enableSticky) this.clearSticky();
        } else {
          clearTimeout(this._peekTimer);
          this._peekTimer = null;
          this.classList.remove('is-peeking');
          const rect = entry.boundingClientRect;
          if (this.enableSticky && rect.top < 0) this.activateSticky();
        }
      });
    }

    activateSticky() {
      if (this.dataset.available !== 'true' || !this.dataset.variantId) return;
      const data = {
        id: this.dataset.productId,
        title: this.dataset.title,
        price: this.dataset.price,
        image: this.dataset.image,
        url: this.dataset.url,
        variantId: this.dataset.variantId,
        available: this.dataset.available === 'true',
        ts: Date.now(),
        dismissed: false,
      };
      try {
        sessionStorage.setItem('etr_sticky_product', JSON.stringify(data));
      } catch (e) {}
      window.dispatchEvent(new CustomEvent('etr:sticky:update', { detail: data }));
    }

    clearSticky() {
      window.dispatchEvent(new CustomEvent('etr:sticky:hide'));
    }
  }

  if (!customElements.get('etr-featured-product')) {
    customElements.define('etr-featured-product', EtrFeaturedProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etr-glitch-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    const num = (v, d) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : d;
    };

    class EtrGlitchHero extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            if (this.isConnected) this.start();
          }, { once: true });
        } else {
          this.start();
        }
      }

      disconnectedCallback() {
        this._token = null;
        this._ready = false;
      }

      start() {
        this._ready = true;
        const token = (this._token = {});
        this._alive = () => this._token === token;
        this.img = this.querySelector('.etr-gh__img');
        this.editing = this.dataset.editing === 'true';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.initCallouts();
        if (!this.editing && !this.reduced) this.initZones();
        this.setAttribute('data-ready', '');
      }

      /* ---------- callouts: same group = take turns, groups run side by side ---------- */
      initCallouts() {
        const items = Array.from(this.querySelectorAll('.etr-co'));
        if (!items.length) return;
        if (this.editing || this.reduced) {
          items.forEach((el) => el.classList.add('is-on'));
          return;
        }
        const groups = {};
        items.forEach((el) => {
          const g = el.dataset.group || '1';
          (groups[g] = groups[g] || []).push(el);
        });
        const stagger = num(this.dataset.stagger, 1.5) * 1000;
        Object.keys(groups)
          .sort()
          .forEach((g, i) => this.runGroup(groups[g], i * stagger));
      }

      async runGroup(list, startDelay) {
        const alive = this._alive;
        const fade = num(this.dataset.fade, 700);
        const hold = num(this.dataset.hold, 3) * 1000;
        const gap = num(this.dataset.gap, 0.5) * 1000;
        await sleep(startDelay);
        if (!alive()) return;
        let i = 0;
        while (alive()) {
          const el = list[i % list.length];
          el.classList.add('is-on');
          await sleep(fade + hold);
          if (!alive()) return;
          el.classList.remove('is-on');
          await sleep(fade + gap);
          if (!alive()) return;
          i++;
        }
      }

      /* ---------- glitch / mosaic zones ---------- */
      initZones() {
        const zones = Array.from(this.querySelectorAll('.etr-zone'));
        if (!zones.length || !this.img) return;
        const go = () => zones.forEach((z) => this.runZone(z));
        if (this.img.complete && this.img.naturalWidth) go();
        else this.img.addEventListener('load', go, { once: true });
      }

      async runZone(zone) {
        const alive = this._alive;
        const every = num(zone.dataset.every, 4) * 1000;
        const canvas = zone.querySelector('canvas');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const tiny = document.createElement('canvas');
        await sleep(Math.random() * every);
        while (alive()) {
          await sleep(every * (0.6 + Math.random() * 0.8));
          if (!alive()) return;
          if (document.hidden) continue;
          await this.burst(zone, canvas, ctx, tiny);
        }
      }

      burst(zone, canvas, ctx, tiny) {
        return new Promise((resolve) => {
          const alive = this._alive;
          const img = this.img;
          const rect = zone.getBoundingClientRect();
          const iw = img.naturalWidth;
          const ih = img.naturalHeight;
          if (rect.width < 2 || rect.height < 2 || !iw) return resolve();

          const d = zone.dataset;
          const mode = d.mode || 'both';
          const block = num(d.block, 14);
          const burstMs = num(d.burst, 500);
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          const W = (canvas.width = Math.round(rect.width * dpr));
          const H = (canvas.height = Math.round(rect.height * dpr));
          const sx = (num(d.x, 0) / 100) * iw;
          const sy = (num(d.y, 0) / 100) * ih;
          const sw = (num(d.w, 10) / 100) * iw;
          const sh = (num(d.h, 10) / 100) * ih;

          const draw = () => {
            ctx.clearRect(0, 0, W, H);
            if (mode !== 'slice') {
              const px = Math.max(3, Math.round(block * (0.6 + Math.random() * 1.4)));
              const cols = Math.max(1, Math.ceil(rect.width / px));
              const rows = Math.max(1, Math.ceil(rect.height / px));
              tiny.width = cols;
              tiny.height = rows;
              const t = tiny.getContext('2d');
              t.imageSmoothingQuality = 'high';
              t.drawImage(img, sx, sy, sw, sh, 0, 0, cols, rows);
              ctx.imageSmoothingEnabled = false;
              ctx.drawImage(tiny, 0, 0, cols, rows, 0, 0, W, H);
            } else {
              ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);
            }
            if (mode !== 'mosaic') {
              const bands = 2 + Math.floor(Math.random() * 4);
              for (let b = 0; b < bands; b++) {
                const bh = Math.max(2, Math.round(H * (0.05 + Math.random() * 0.18)));
                const by = Math.floor(Math.random() * Math.max(1, H - bh));
                const shift = Math.round((Math.random() - 0.5) * W * 0.35);
                ctx.drawImage(img, sx, sy + (by / H) * sh, sw, (bh / H) * sh, shift, by, W, bh);
              }
            }
            if (Math.random() < 0.35) {
              ctx.fillStyle = 'rgba(30, 77, 255, 0.28)';
              ctx.fillRect(0, Math.floor(Math.random() * H), W, Math.max(2, Math.round(H * 0.06)));
            }
          };

          canvas.style.opacity = '1';
          const t0 = performance.now();
          let last = -1000;
          const tick = (t) => {
            if (!alive() || t - t0 >= burstMs) {
              canvas.style.opacity = '0';
              return resolve();
            }
            if (t - last > 70) {
              last = t;
              draw();
            }
            requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      }
    }

    if (!customElements.get('etr-glitch-hero')) {
      customElements.define('etr-glitch-hero', EtrGlitchHero);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etr-product"] && !Shopify.designMode) return;
  try {
    
  class EtrProduct extends HTMLElement {
    connectedCallback() {
      this.variants = this.readJSON('#etr-pp-variants') || [];
      this.sizeOptionIndex = parseInt(this.dataset.sizeOptionIndex, 10);
      this.selectedOptions = this.getInitialOptions();

      [this.bindGallery, this.bindSizePills, this.bindQuantity, this.bindAccordions].forEach((fn) => {
        try {
          fn.call(this);
        } catch (e) {
          console.error('etr-product:', fn.name, e);
        }
      });
    }

    readJSON(selector) {
      const el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    getInitialOptions() {
      const idInput = this.querySelector('#etr-pp-variant-id');
      if (!idInput) return [];
      const current = this.variants.find((v) => String(v.id) === idInput.value);
      return current ? current.options.slice() : [];
    }

    findVariant(options) {
      return this.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
    }

    bindGallery() {
      const main = this.querySelector('#etr-pp-main-image');
      this.querySelectorAll('.etr-pp__thumb').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (main) main.src = btn.dataset.full;
          this.querySelectorAll('.etr-pp__thumb').forEach((b) => b.classList.remove('etr-pp__thumb--active'));
          btn.classList.add('etr-pp__thumb--active');
        });
      });
    }

    bindSizePills() {
      const pills = this.querySelectorAll('.etr-pp__size-pill');
      if (!pills.length || this.sizeOptionIndex < 0) return;
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const options = this.selectedOptions.slice();
          options[this.sizeOptionIndex] = pill.dataset.value;
          const variant = this.findVariant(options);
          if (!variant) return;
          this.selectedOptions = options;
          pills.forEach((p) => p.classList.remove('etr-pp__size-pill--active'));
          pill.classList.add('etr-pp__size-pill--active');
          this.applyVariant(variant);
        });
      });
    }

    applyVariant(variant) {
      const idInput = this.querySelector('#etr-pp-variant-id');
      if (idInput) idInput.value = variant.id;
      const label = this.querySelector('#etr-pp-size-selected');
      if (label) label.textContent = variant.title;
      const priceEl = this.querySelector('.etr-pp__price');
      if (priceEl && variant.price != null) {
        priceEl.childNodes[0].textContent = this.formatMoney(variant.price) + ' ';
      }
      const addBtn = this.querySelector('#etr-pp-add');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.dataset.label || addBtn.textContent)
          : 'Sold out';
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    bindQuantity() {
      const input = this.querySelector('#etr-pp-qty');
      this.querySelectorAll('.etr-pp__qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.step, 10);
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    }

    bindAccordions() {
      this.querySelectorAll('[data-accordion-toggle]').forEach((trigger) => {
        const key = trigger.dataset.accordionToggle;
        const panel = this.querySelector(`[data-accordion-panel="${key}"]`);
        if (!panel) return;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => {
          const open = panel.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
  }

  if (!customElements.get('etr-product')) {
    customElements.define('etr-product', EtrProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etr-sticky-cart"]) return;
  try {
    
  class EtrStickyCart extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('.etr-sticky__link');
      this.img = this.querySelector('.etr-sticky__img');
      this.titleEl = this.querySelector('.etr-sticky__title');
      this.priceEl = this.querySelector('.etr-sticky__price');
      this.addBtn = this.querySelector('.etr-sticky__add');
      this.closeBtn = this.querySelector('.etr-sticky__close');
      this.autoHideSeconds = parseInt(this.dataset.autoHide || '25', 10);
      this._hideTimer = null;

      this.closeBtn.addEventListener('click', () => this.dismiss());
      this.addBtn.addEventListener('click', () => this.addToCart());
      window.addEventListener('etr:sticky:update', (e) => this.show(e.detail));
      window.addEventListener('etr:sticky:hide', () => this.hide());

      this.checkSession();
    }

    checkSession() {
      let data;
      try {
        data = JSON.parse(sessionStorage.getItem('etr_sticky_product') || 'null');
      } catch (e) {
        data = null;
      }
      if (data && !data.dismissed) this.show(data);
    }

    show(data) {
      if (!data) return;
      this.data = data;
      this.img.src = data.image || '';
      this.titleEl.textContent = data.title || '';
      this.priceEl.textContent = data.price || '';
      this.link.href = data.url || '#';
      this.addBtn.textContent = data.available ? 'Add to cart' : 'View item';
      this.addBtn.disabled = false;
      this.classList.add('is-visible');
      this.armAutoHide();
    }

    hide() {
      this.classList.remove('is-visible');
      clearTimeout(this._hideTimer);
    }

    dismiss() {
      if (this.data) {
        this.data.dismissed = true;
        try {
          sessionStorage.setItem('etr_sticky_product', JSON.stringify(this.data));
        } catch (e) {}
      }
      this.hide();
    }

    armAutoHide() {
      clearTimeout(this._hideTimer);
      if (this.autoHideSeconds > 0) {
        this._hideTimer = setTimeout(() => this.hide(), this.autoHideSeconds * 1000);
      }
    }

    addToCart() {
      if (!this.data || !this.data.available) {
        window.location.href = this.data ? this.data.url : '#';
        return;
      }
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.data.variantId, quantity: 1 }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(() => {
          this.addBtn.textContent = 'Added';
          try {
            if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'etr-sticky-cart' });
            }
          } catch (e) {}
          setTimeout(() => this.hide(), 1500);
        })
        .catch(() => {
          this.addBtn.textContent = 'Try again';
          this.addBtn.disabled = false;
        });
    }
  }

  if (!customElements.get('etr-sticky-cart')) {
    customElements.define('etr-sticky-cart', EtrStickyCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
